// extracted by mini-css-extract-plugin
export default {"flex":"VoucherNumber_flex__o-j7a","title":"VoucherNumber_title__dQTJ2","input_text":"VoucherNumber_input_text__oqGkS"};